import axios from 'axios'
import { REACT_APP_API } from '../../../config'

export async function editDictionaryTranslation(id, translation) {
  const response = await axios.put(
    `${REACT_APP_API}/dictionary/`,
    { data: { translation }, where: { id } }
  )
  return response.data
}